import React from "react";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import styled from "styled-components";
import { useMsal } from "@azure/msal-react";
import "./user.css";

const UserMenu = ({ setIsSignedIn }) => {
  const { instance } = useMsal();

  const currentUser = JSON.parse(sessionStorage.getItem("user") || "{}");
  const loggedInUser =
    (currentUser.firstName || "") + " " + (currentUser.lastName || "");

  const handleLogout = async () => {
    console.log("LOGOUT CLICKED");

    // ✅ 1) Clear your app session completely
    sessionStorage.clear();
    setIsSignedIn(false);

    // ✅ 2) Clear MSAL cache + Entra browser session
    await instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin + "/",
    });
  };

  return (
    <Container>
      <IconButton>
        <AccountCircle className="avatar" />
      </IconButton>

      <Select
        value="placeholder"
        style={{
          display: "flex",
          justifyContent: "space-between",
          height: "60px",
          color: "#FFFFFF",
        }}
        variant="standard"
        disableUnderline
      >
        <MenuItem value="placeholder" disabled>
          {loggedInUser}
        </MenuItem>

        <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
      </Select>
    </Container>
  );
};

export default UserMenu;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 50px;
`;
